import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface Faq {
  q: string;
  a: string;
}

export const DEFAULT_FAQS: Faq[] = [
  {
    q: "How do I book a transfer?",
    a: "Simply enter your pick-up and drop-off locations in the booking form, select the number of passengers, and choose your preferred vehicle. You'll see instant pricing and can complete your reservation online.",
  },
  {
    q: "What airports do you cover?",
    a: "We cover all major airports in the Dominican Republic: Punta Cana (PUJ), Santo Domingo (SDQ), Santiago (STI), La Romana (LRM), Puerto Plata (POP), and Samaná (AZS).",
  },
  {
    q: "Can I cancel or modify my booking?",
    a: "Yes! Free cancellation is available up to 24 hours before your scheduled pick-up. Modifications can be made anytime by contacting our support team.",
  },
  {
    q: "How is the price calculated?",
    a: "Prices are based on zones and vehicle type. Airport-to-hotel transfers have fixed zone rates, while hotel-to-hotel transfers are calculated based on distance. Round trips receive a discount.",
  },
  {
    q: "Are your drivers licensed?",
    a: "Absolutely. All Express Punta Cana drivers are professionally licensed, fully vetted, and trained to provide a safe, comfortable experience. Vehicles are insured and regularly maintained.",
  },
];

export function useFaqs() {
  const [faqs, setFaqs] = useState<Faq[]>(DEFAULT_FAQS);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const { data } = await supabase
        .from("faqs")
        .select("question,answer")
        .eq("is_active", true)
        .order("sort_order");
      if (!mounted || !data || data.length === 0) return;
      setFaqs(data.map((r) => ({ q: r.question, a: r.answer })));
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return faqs;
}
